import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type IBankAccountRepository } from 'application/repositorySchemas/IBankAccountRepository';
import { type IBankAccountClient } from 'interfaceAdapter/gatewaySchemas/IBankAccountClient';
import { BankAccount } from 'ui/components/supporter/patterns/TransferList/BankAccountManagement';

@injectable()
export class BankAccountRepository implements IBankAccountRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IBankAccountClient')
        public readonly bankAccountClient: IBankAccountClient,
    ) {}

    public async save(account: Partial<BankAccount>): Promise<void> {
        const { message } = await this.bankAccountClient.post({
            token: this.supportUserToken.get() || '',
            bank_code: account.bank_code || null,
            bank_name: account.bank_name || '',
            bank_branch_code: account.bank_branch_code || null,
            branch_name: account.branch_name || '',
            account_type: account.account_type || 'normal',
            account_holder_kana: account.account_holder_kana || '',
        });

        if (message) {
            throw new Error(message);
        }
    }
}
